'use client';

import { Oval } from 'react-loader-spinner';

import styles from './styles.module.scss';
import { Props } from './types';

const Loader = ({
  withPadding = true,
  customHeight = 65,
  customWidth = 65,
}: Props) => {
  return (
    <Oval
      height={customHeight}
      width={customWidth}
      color={styles.primaryColorLight}
      wrapperStyle={{}}
      wrapperClass={[styles.spinner, withPadding && styles.withPadding].join(
        ' ',
      )}
      visible={true}
      ariaLabel="oval-loading"
      secondaryColor={styles.primaryColor}
      strokeWidth={2}
      strokeWidthSecondary={2}
    />
  );
};

export default Loader;
